
export const getName = (room, user) => {
  if (room.name) return room.name
  const num_members = room.users.length
  const member_names = room.users
    .filter((u) => {
      return u.id !== user.id
    })
    .map((u) => {
      return u.name || u.email
    })
  if (num_members > 2) {
    if (room.name) { // has a name
      return room.name
    } else {
      const name_length = member_names.reduce((curr, next) => {
        const last_length = curr[curr.length - 1]
        curr.push(last_length + next.length + 2)
        return curr
      }, [0])
      const idx = name_length.findIndex((val) => {
        return val > 16
      })
      return member_names.slice(0, idx - 1).join(', ') + `... +${num_members - idx}`
    }
  } else {
    return member_names.length === 1 
      ? member_names[0]
      : 'Notes to Self'
  }
}
